import {styled} from "@mui/material/styles"

export const Cashmere25FacetListSelectLabel = styled("span")`
    font-weight: ${({theme}) => `${theme.colours.typography.body3.fontWeight}`};
    font-family: ${({theme}) => `${theme.colours.typography.body3.fontFamily}, ${theme.colours.font.default}`};
`
export default Cashmere25FacetListSelectLabel
